import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FormatarData } from "../../../../shared/formatarData";
import { RetornoSelecao } from "../../../../shared/gridview/RetornoSelecao";
import { Estado } from "../../../../shared/shared/estado.enum";
import { PaServiceService } from "../pa-service.service";

declare var jquery: any;
declare var $: any;

@Component({
  selector: "app-resultado-PA",
  template: `<div>
    <app-pa-filtro [filtros]="filtros"> </app-pa-filtro>
    <app-pa-lista
      [filtros]="filtros"
      (definirFiltro)="definirFiltro()" 
      (exibir)="selecionar($event)"
    >
    </app-pa-lista>
  </div> `,
})
export class ResultadoPAComponent implements OnInit {
  selecionado: object;
  state: Estado = Estado.view;
  filtros = {};

  parametrosFiltro: any;
  InicialData; // Set the first Day of month
  FinalData; // set the last day of query

  constructor(
    private route: ActivatedRoute,
    private service: PaServiceService
  ) {
    this.route.queryParams.subscribe((params) => {
      this.parametrosFiltro = params;
      this.setaValorData(params["data_inicial"], params["data_final"]);
      this.carregarFiltrosParametros();
    });
  }

  ngOnInit() {
    const marca: any = {
      marcas: [40, 31],
    };

    this.service.getTotais(marca);
  }

  setaValorData(dataInicial: Date, dataFinal: Date) {
    const dt = new Date();
    if (dataInicial === undefined || dataInicial.toString() === "") {
      const dataInicio = {
        year: dt.getFullYear(),
        month: dt.getMonth() + 1,
        day: 1,
      };
      const dataInicialFormata = new FormatarData(
        dataInicio.year,
        dataInicio.month,
        dataInicio.day,
        0,
        0,
        0
      ).getDataString();
      this.InicialData = dataInicialFormata;
    } else {
      const now = new Date(dataInicial);
      this.InicialData =
        now.getFullYear() +
        "-" +
        ("0" + (now.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + now.getUTCDate()).slice(-2);
    }

    if (dataFinal === undefined || dataFinal.toString() === "") {
      const dataFim = {
        year: dt.getFullYear(),
        month: dt.getMonth() + 1,
        day: dt.getUTCDate(),
      };
      const dataFinalFormata = new FormatarData(
        dataFim.year,
        dataFim.month,
        dataFim.day,
        0,
        0,
        0
      ).getDataString();
      this.FinalData = dataFinalFormata;
    } else {
      const now = new Date(dataFinal);
      this.FinalData =
        now.getFullYear() +
        "-" +
        ("0" + (now.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + now.getUTCDate()).slice(-2);
    }

    this.filtros = {
      data_inicial: this.InicialData,
      data_final: this.FinalData,
    };
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {
          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  buscar() {
    this.selecionado = undefined;
    this.state = Estado.view;
  }

  selecionar(selecionado: RetornoSelecao) {
    if (selecionado.novoCadastro) {
      this.state = Estado.insert;
    } else {
      this.state = Estado.view;
    }
    this.selecionado = selecionado.registro;
  }

  definirFiltro() {
    $("#resultado-pa-filtro").modal();
  }
}
